import { SubmissionStatus } from '@bp/bp-graphql-types';
import { EmptyState, NoTasksIcon } from '@bp/ui-components';
import { useAssignments } from 'components/Assignments/hooks/useAssignments';
import { BpHeader } from 'components/BpHeader/BpHeader';
import { useRequireParams } from 'hooks/useRequireParams';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { AssignmentCardStudent } from '../AssignmentCard/AssignmentCardStudent';
import styles from './AssignmentPreview.module.scss';

type AssignmentPreviewStudentProps = {
  onNavigate: (uuid: string) => void;
};

export const AssignmentPreviewStudent = ({ onNavigate }: AssignmentPreviewStudentProps) => {
  const { t } = useTranslation();
  const { courseUuid } = useRequireParams(['courseUuid']);

  const [showTodo, setShowTodo] = useState<boolean>(false);

  const { activeAssignments } = useAssignments({ courseUuid });

  const assignments = !showTodo
    ? activeAssignments
    : activeAssignments.filter((a) => a.submissions.some((s) => s.status === SubmissionStatus.Todo));

  return (
    <div className={styles['assignment-preview']}>
      <BpHeader
        headline={t('assignments.active')}
        subHeadline={assignments.length}
        showSubHeadlineAsChip
        actions={[
          {
            text: !showTodo ? t('submissions.showTodo') : t('common.showAll'),
            callback: () => setShowTodo((prev) => !prev),
            hierarchy: 'secondary',
          },
        ]}
      />
      {assignments.length === 0 ? (
        <EmptyState
          size='small'
          backgroundColor='var(--color-white)'
          subtitle={t('assignments.noAssignments')}
          icon={<NoTasksIcon />}
          forcedWidth='300px'
          forcedHeight='164px'
        />
      ) : (
        <div className={styles.assignments}>
          {assignments.map((assignment) => (
            <AssignmentCardStudent
              key={assignment.uuid}
              assignmentUuid={assignment.uuid}
              onNavigate={(uuid) => onNavigate(uuid)}
            />
          ))}
        </div>
      )}
    </div>
  );
};
